import { Component, Input, OnChanges } from '@angular/core';
import {
  FsAnalyticsData,
} from '../pojo/fund-strategy-export-classes';
import { FpModifyValuePipe } from "../../../../util/pipes/fp-modify-value.pipe";
import { SwitcherDashBracesPipe } from "../../../../util/pipes/switcherDashBraces.pipe";



@Component({
  selector: 'app-fund-strategy-analytics',
  templateUrl: './fund-strategy-analytics.component.html',
  styleUrls: ['./fund-strategy-analytics.component.scss'],
  imports: [
    FpModifyValuePipe,
    SwitcherDashBracesPipe
]
})

export class FundStrategyAnalyticsComponent implements OnChanges {

  @Input({ required: true }) isModelBlocked = false;
  @Input({ required: true }) analyticsData: FsAnalyticsData = new FsAnalyticsData();

  ngOnChanges(): void {
    if (this.isModelBlocked) {
      this.analyticsData = new FsAnalyticsData();
    }
  }
}
